




























































































































import Vue from "vue";

import BottomDialog from "./BottomDialog.vue";

export default Vue.extend({
  components: {
    BottomDialog
  },
  methods: {
    getScrollableElement() {
      return document.querySelector(".rules .content-box");
    }
  }
});
